export const messages = {
  en: {
    affiliateRelationManage: {
      queryCondition: 'Query Condition',
      relationTableInfo: 'Affiliate Relation Table',
      addRelation: 'Add Affiliate Relation',
      relationId: 'Relation ID',
      affiliateId: 'Affiliate ID',
      recommendedUserId: 'Recommended User ID',
      relationLevel: 'Relation Level',
      expireTime: 'Expire Time',
      createTime: 'Create Time',
      operation: 'Operation',
      selectRelationLevel: 'Please select relation level',
      confirmDeleteRelation: 'Are you sure to delete this affiliate relation?',
      relationLevelRequired: 'Required, please enter relation level',
      relationLevelMaxLength: 'Relation level cannot exceed 30 characters',
      expireTimeRequired: 'Required, please enter expire time',
      expireTimeMaxLength: 'Expire time cannot exceed 200 characters',
      editRelation: 'Edit Affiliate Relation'
    }
  },
  zh: {
    affiliateRelationManage: {
      queryCondition: '查询条件',
      relationTableInfo: '分销关系表信息',
      addRelation: '添加分销关系表',
      relationId: '关系ID',
      affiliateId: '分销员ID',
      recommendedUserId: '被推荐用户ID',
      relationLevel: '关系层级',
      expireTime: '过期时间',
      createTime: '创建时间',
      operation: '操作',
      selectRelationLevel: '请选择分销关系',
      confirmDeleteRelation: '确定删除分销关系表',
      relationLevelRequired: '必填，请填写关系层级',
      relationLevelMaxLength: '关系层级不能超过30个字符',
      expireTimeRequired: '必填，请填写过期时间',
      expireTimeMaxLength: '过期时间不能超过200个字符',
      editRelation: '修改分销关系表'
    }
  }
}